import { Chip } from "@mui/material";
import { LabelValueForTags } from "components/ui/atoms/LabelValue";
import { getCommons } from "./fieldConverterHelpers";

export const multiSelectValueFormatter = (value, row, colDef, apiRef) => {
  return Array.isArray(value)
    ? value
        .map(
          (v) =>
            colDef.valueOptions?.find((opt) => opt.value === v)?.label || v,
        )
        .join(", ")
    : "";
};

export const MultipleChoiceFieldView = ({ field, value }) => {
  const options =
    field.choices?.filter((option) => value.includes(option.value)) || value;

  return (
    <LabelValueForTags
      label={field.label}
      Tags={options.map((option, index) => (
        <Chip key={index} label={`${option.label}`} size="small" />
      ))}
      sx={{ display: field.hidden ? "none" : "inherit" }}
    />
  );
};

export const multipleChoiceFieldConverter = ({ field }) => {
  if (!field.choices) {
    console.warn(`No choices provided for field ${field.name}`);
  }

  return {
    ...getCommons({ field }),
    type: "singleSelect",
    valueOptions: field.choices || [],
    valueFormatter: multiSelectValueFormatter,
    width: field.width || 150,
  };
};
